var map = {
	"./de/namespaces/businessSettings.js": [
		7736,
		3520
	],
	"./en/namespaces/businessSettings.js": [
		23360
	],
	"./es/namespaces/businessSettings.js": [
		63319,
		2711
	],
	"./fr/namespaces/businessSettings.js": [
		27743,
		4879
	],
	"./it/namespaces/businessSettings.js": [
		3422,
		3590
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3904;
module.exports = webpackAsyncContext;